import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('enrichment/demandbase')

export const FETCH_DEMANDBASE_COMPANY_DATA = makeConstant('FETCH_DEMANDBASE_COMPANY_DATA')
export const FETCH_DEMANDBASE_COMPANY_DATA_PENDING = makeConstant('FETCH_DEMANDBASE_COMPANY_DATA_PENDING')
export const FETCH_DEMANDBASE_COMPANY_DATA_SUCCESS = makeConstant('FETCH_DEMANDBASE_COMPANY_DATA_SUCCESS')
export const FETCH_DEMANDBASE_COMPANY_DATA_FAILED = makeConstant('FETCH_DEMANDBASE_COMPANY_DATA_FAILED')
export const FETCH_DEMANDBASE_COMPANY_DATA_CANCELLED = makeConstant('FETCH_DEMANDBASE_COMPANY_DATA_CANCELLED')

export const FETCH_DEMANDBASE_TARGETING_INDUSTRIES = makeConstant('FETCH_DEMANDBASE_TARGETING_INDUSTRIES')
export const FETCH_DEMANDBASE_TARGETING_INDUSTRIES_PENDING = makeConstant('FETCH_DEMANDBASE_TARGETING_INDUSTRIES_PENDING')
export const FETCH_DEMANDBASE_TARGETING_INDUSTRIES_SUCCESS = makeConstant('FETCH_DEMANDBASE_TARGETING_INDUSTRIES_SUCCESS')
export const FETCH_DEMANDBASE_TARGETING_INDUSTRIES_FAILED = makeConstant('FETCH_DEMANDBASE_TARGETING_INDUSTRIES_FAILED')

export const FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES = makeConstant('FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES')
export const FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_PENDING = makeConstant('FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_PENDING')
export const FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_SUCCESS = makeConstant('FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_SUCCESS')
export const FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_FAILED = makeConstant('FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_FAILED')


// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/demandbase/constants.js